const DateIcon = ({ className, style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
      className={className}
      style={style}>
      <path
        d="M4.16699 0V1.66699H10.833V0H12.5V1.66699H13.333C14.2497 1.66699 15 2.41732 15 3.33398V15C15 15.9167 14.2497 16.667 13.333 16.667H1.66699C0.741992 16.667 0 15.9167 0 15L0.00878906 3.33398C0.00878906 2.41732 0.741992 1.66699 1.66699 1.66699H2.5V0H4.16699ZM1.66699 5.83398V15H13.333V5.83398H1.66699ZM10 10.832H11.667V11.665H10V13.332H9.16699V11.665H7.5V10.832H9.16699V9.16504H10V10.832Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DateIcon;
